import { TSignupStepsUK } from '../types';

type TResolveVariantRoute = {
  currentStep: string;
  requestedRoute: TSignupStepsUK;
  aiEnabled?: boolean;
};

/**
 * Rewrite the eight navigation edges that differ in the
 * new_customers_step_0_eligibility_2026 variant, where check-eligibility comes
 * straight after new. Any pair not listed passes through untouched, which is
 * what keeps the control arm and the unaffected variant edges identical.
 */
export const resolveVariantRoute = ({
  currentStep,
  requestedRoute,
  aiEnabled = false,
}: TResolveVariantRoute): TSignupStepsUK => {
  if (currentStep === 'new' && requestedRoute === 'business') {
    return 'check-eligibility';
  }

  if (currentStep === 'business' && requestedRoute === 'check-eligibility') {
    return 'applicant';
  }

  if (
    currentStep === 'company-questions' &&
    requestedRoute === 'check-eligibility'
  ) {
    return 'applicant';
  }

  if (currentStep === 'check-eligibility' && requestedRoute === 'applicant') {
    return 'business';
  }

  if (
    currentStep === 'check-eligibility' &&
    (requestedRoute === 'business' || requestedRoute === 'company-questions')
  ) {
    return 'new';
  }

  if (currentStep === 'business' && requestedRoute === 'new') {
    return 'check-eligibility';
  }

  if (currentStep === 'applicant' && requestedRoute === 'check-eligibility') {
    return aiEnabled ? 'company-questions' : 'business';
  }

  return requestedRoute;
};
